import {
  getInternships
} from '~api/intern'

export const state = () => ({
  internships: []
})

export const getters = {
  internshipsGetter: state => state.internships
}

export const actions = {
  async getInternships ({ commit }) {
    const internships = await getInternships()

    commit('setInternships', internships)

    return internships
  }
}

export const mutations = {
  setInternships (state, payload) {
    state.internships = payload
  }
}
